import { AccessLevel } from '@/types/app';

export const isAccessibleForFree = (accessLevel?: AccessLevel) => {
  return (accessLevel ?? 'open') === 'open';
};
